/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_Score_ColumnInputs */

const en_admin_statistics_score_column = /** @type {(inputs: Admin_Statistics_Score_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching score`)
};

const de_admin_statistics_score_column = /** @type {(inputs: Admin_Statistics_Score_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching Score`)
};

/**
* | output |
* | --- |
* | "Matching score" |
*
* @param {Admin_Statistics_Score_ColumnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_score_column = /** @type {((inputs?: Admin_Statistics_Score_ColumnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Score_ColumnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_score_column(inputs)
	return en_admin_statistics_score_column(inputs)
});